var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "view-messages",
      class: { "view-messages--overlay": _vm.overlay },
    },
    [
      _c(
        "transition-group",
        { attrs: { name: "list", tag: "div" } },
        _vm._l(_vm.messages, function (message) {
          return _c(
            "div",
            {
              key: message.name,
              class: `alert alert-${message.type} alert-dismissible`,
              attrs: { role: "alert" },
            },
            [
              _c("span", { domProps: { innerHTML: _vm._s(message.text) } }),
              _vm._v(" "),
              _c("button", {
                staticClass: "btn-close",
                attrs: {
                  type: "button",
                  "data-bs-dismiss": "alert",
                  "aria-label": "Close",
                },
                on: {
                  click: function ($event) {
                    return _vm.close(message.name)
                  },
                },
              }),
            ]
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }